import * as React from 'react';
import classnames from '../../../utils/classnames.tsx';
import { Slot } from '@radix-ui/react-slot';

interface HeaderButtonProps extends React.ComponentPropsWithoutRef<'button'> {
    active?: boolean;
    variant?: 'outline' | 'ghost';
    asChild?: boolean;
}

const PageHeaderButton = ({ className, asChild, active = false, variant = 'outline', ...props }: HeaderButtonProps) => {
    const Comp: any = asChild ? Slot : 'button';
    return (
        <Comp
            className={classnames(
                'flex shrink-0 items-center justify-center whitespace-nowrap border border-solid border-line-strong outline-none px-3 gap-2 rounded transition-colors hover:bg-surface-strong h-8 cursor-pointer text-sm font-medium text-content-strong hover:text-content-strong disabled:opacity-50 disabled:pointer-events-none data-[state=open]:bg-surface-brand-medium-default data-[state=open]:text-content-brand-strong',
                variant === 'outline' &&
                    'bg-surface-weak border-line-strong shadow-control data-[state=open]:border-line-brand-default',
                active && variant === 'outline' && '!border-line-brand-default',
                variant === 'ghost' && 'bg-surface-transparent border-line-transparent',
                active &&
                    '!bg-surface-brand-medium-default !text-content-brand-strong hover:!bg-surface-brand-medium-hover active:!bg-surface-brand-medium-active',
                className
            )}
            {...props}
        />
    );
};

export const PageHeaderIconButton = ({ className, ...props }: HeaderButtonProps) => {
    return <PageHeaderButton className={classnames('w-8 h-8 px-0', className)} {...props} />;
};

export default PageHeaderButton;
